import { subDays } from "date-fns";

import { SourceUsageTableRow } from "../SourceTable";
import {
  SourceUsageChartPoint,
  SourceUsageChartSeriesItem,
} from "./types";
import { formatSourceUsageDate } from "./utils/formatSourceUsageDate";

const LAST_DAYS_COUNT = 8;

function buildLast8Days(): string[] {
  const today = new Date();
  return Array.from({ length: LAST_DAYS_COUNT }, (_, i) => {
    const d = subDays(today, LAST_DAYS_COUNT - 1 - i);
    return formatSourceUsageDate(d);
  });
}

const LAST_8_DATE_LABELS = buildLast8Days();

export const MOCK_CHART_DATA: SourceUsageChartPoint[] = LAST_8_DATE_LABELS.map(
  (date, i) => ({
    date,
    reddit: 25 + i * 4 + (i % 3) * 5,
    techcrunch: 20 + i * 3 + (i % 2) * 4,
    youtube: 18 + i * 2 + (i % 4) * 3,
    techradar: 15 + i * 2 + (i % 2) * 2,
    wikipedia: 12 + i * 2 + (i % 3) * 2,
  })
);

export const MOCK_CHART_SERIES: SourceUsageChartSeriesItem[] = [
  {
    dataKey: "reddit",
    name: "reddit.com",
    color: "var(--aicarma-color-fuchsia)",
  },
  {
    dataKey: "techcrunch",
    name: "techcrunch.com",
    color: "var(--aicarma-color-gray)",
  },
  {
    dataKey: "youtube",
    name: "youtube.com",
    color: "var(--aicarma-color-red)",
  },
  {
    dataKey: "techradar",
    name: "techradar.com",
    color: "var(--aicarma-color-blue2)",
  },
  {
    dataKey: "wikipedia",
    name: "wikipedia.com",
    color: "var(--aicarma-color-green)",
  },
];

export const MOCK_TABLE_ROWS: SourceUsageTableRow[] = [
  {
    id: "1",
    index: 1,
    name: "reddit.com",
    logoText: "r",
    domainType: "news",
    linksCount: 5,
    usagePercent: 42,
    citations: 12,
    averageCitations: 1.2,
    detailHref: "/source/1/",
  },
  {
    id: "2",
    index: 2,
    name: "techcrunch.com",
    logoText: "t",
    domainType: "news",
    linksCount: 2,
    usagePercent: 40,
    citations: 10,
    averageCitations: 2.1,
    detailHref: "/source/2/",
  },
  {
    id: "3",
    index: 3,
    name: "wikipedia.com",
    logoText: "w",
    domainType: "forum",
    linksCount: 3,
    usagePercent: 36,
    citations: 8,
    averageCitations: 1.6,
    detailHref: "/source/3/",
  },
  {
    id: "4",
    index: 4,
    name: "youtube.com",
    logoText: "y",
    domainType: "other",
    linksCount: 2,
    usagePercent: 33,
    citations: 6,
    averageCitations: 1.5,
    detailHref: "/source/4/",
  },
  {
    id: "5",
    index: 5,
    name: "techradar.com",
    logoText: "t",
    domainType: "news",
    linksCount: 1,
    usagePercent: 32,
    citations: 4,
    averageCitations: 1.9,
    detailHref: "/source/5/",
  },
];
